export default "__VITE_ASSET__f9250666__"